import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { GraduationCap } from 'lucide-react';
import ErrorBoundary from '../components/ErrorBoundary';
import { useMixpanelPageTracking } from '../hooks/useMixpanelPageTracking';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({
  children
}) => {
  // Track page views
  useMixpanelPageTracking();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}
    >
      <Box sx={{ width: '100%', maxWidth: '460px' }}>
        <Paper
          elevation={10}
          sx={{
            p: { xs: '28px', md: '36px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: '#FFFFFF',
            borderRadius: '20px',
            border: '1px solid rgba(124,99,216,0.12)',
            boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 64,
              height: 64,
              borderRadius: 3,
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              mb: 2
            }}
          >
            <GraduationCap size={32} />
          </Box>

         

          {/* Content */}
          <Box sx={{ width: '100%' }}>
            <ErrorBoundary>
              {children}
            </ErrorBoundary>
          </Box>

          {/* Footer */}
          <Box
            sx={{
              mt: 3,
              pt: 2,
              borderTop: '1px solid #E5E7EB',
              textAlign: 'center',
            }}
          >
            <Typography variant="caption" sx={{ color: '#9CA3AF' }}>
              Trusted • Secure • Educational Excellence
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Box>  
  );
};

export default AuthLayout;